import { msg } from '@lingui/macro'

import * as React from 'react'

import { NoteInput } from '~shared/segments/Form'

import { useRememberNote } from '../hooks/useRememberNote'

type TProps = NoChildren & {
  persistNote: FirstParam<typeof useRememberNote>['persistNote']
}

/**
 * Note input used on the Form screen.
 */
export const OrderNoteInput: React.FC<TProps> = ({ persistNote }: TProps) => {
  useRememberNote({ persistNote })
  return (
    <NoteInput
      placeholder={msg`For example some information related to the whole order or specific instructions for a driver`}
    />
  )
}
